export default __webpack_public_path__ + "static/media/musa.109806ec.png";